import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { reject } from 'core-js/fn/promise';
import router from '@/router'

Vue.use(Vuex)

// const mainurl = 'http://192.168.1.105:8000';
const mainurl = 'https://appapi.akambc.com';

let state = {
    token: localStorage.getItem('token') || '',
    name: localStorage.getItem('name') || '',
    picture: localStorage.getItem('img') || '',
    last_name: localStorage.getItem('last_name') || '',
}
const mutations = {
    auth_success(state, token) {
        state.token = token
    },
    admin_info(state, payload) {
        state.name = payload.name
        state.last_name = payload.last_name
        state.picture = payload.picture
    },
    logout(state) {
        state.token = ''
    },
    changeInfo(state, payload) {
        state.name = payload.name
        state.last_name = payload.last_name
    }

}
const actions = {
    loginAdmin({ commit }, payload) {
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/login`, data: payload.userDetails, method: 'POST', headers: { Authorization: "" } })
            .then(res => {
                const token = res.data.access_token
                localStorage.setItem('token', token)
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
                localStorage.setItem('name', res.data.data[0].name)
                localStorage.setItem('last_name', res.data.data[0].last_name)
                localStorage.setItem('img', res.data.data[0].picture)
                commit('auth_success', token)
                commit('admin_info', res.data.data[0])
                router.push(router.currentRoute.query.to || '/')
                resolve(res)
            })
            .catch(err => {
                localStorage.clear();
                delete axios.defaults.headers.common['Authorization']
                reject(err)
            })
        })
    },

    resetPassword( { commit } ,payload) {
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/resetPassword`, data: payload, method: 'POST', headers: { Authorization: "" } })
            .then(res => {
                commit('nothing')
                resolve(res)
            })
            .catch(err => {
                localStorage.clear();
                delete axios.defaults.headers.common['Authorization']
                reject(err)
            })
        })
    },

    logoutAdmin({ dispatch }){
        return new Promise((resolve) => {
            const token = localStorage.getItem('token')
            axios({ url: `${mainurl}/api/admin/logout`, data: `Bearer ${token}`, method: 'POST' })
            .then(() => {
                localStorage.clear();
                delete axios.defaults.headers.common['Authorization']
                router.push({ name: "page-login" })
                resolve()
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    getAdminInfo({ commit, dispatch }) {
        return new Promise((resolve) => {
            axios({ url: `${mainurl}/api/admin/me`, method: 'GET' })
            .then( res => {
                commit("auth_success", localStorage.getItem('token'))
                localStorage.setItem('name', res.data.name)
                localStorage.setItem('last_name', res.data.last_name)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    updateProfile({ commit, dispatch }, payload){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/update`, data: payload, method: 'POST' })
            .then(res => {
                localStorage.setItem('name', payload.name)
                localStorage.setItem('last_name', payload.last_name)
                commit('changeInfo', payload)
                router.push({ name: "home" })
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    refresh() {
        return new Promise((resolve) => {
            axios({ url: `${mainurl}/api/admin/refresh`, method: 'GET' })
            .then( res => {
                resolve(res)
            })
        })
    },

    analytics({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            axios({ url: `${mainurl}/api/admin/analytics`, method: 'GET' })
            .then( res => {
                commit("nothing")
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    charts({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            axios({ url: `${mainurl}/api/admin/charts`, method: 'GET' })
            .then( res => {
                commit("nothing")
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    goLogin(){
        localStorage.clear();
        delete axios.defaults.headers.common['Authorization']
        router.push({ name: "page-login" })
    },



}
const modules = {

}
const getters = {
    // userInfo: state => { return state.name }
}
export default({
    state,
    mutations,
    actions,
    getters,
    modules,
    axios
})
